import React from 'react';

import { Heading, Stack } from '@eluve/components';
import { useTenantIdFromParams } from '@eluve/session-helpers';

import { AssetDeletionRequestsTable } from './AssetDeletionRequestsTable';

export const TenantAssetDeletionHistoryPage: React.FC = () => {
  const tenantId = useTenantIdFromParams();

  return (
    <Stack gap={8}>
      <Heading size="xl" weight="semibold">
        Jobs history for this organization{' '}
      </Heading>
      <AssetDeletionRequestsTable tenantId={tenantId!} />
    </Stack>
  );
};
